import React from 'react'
import { DefaultContainer } from '../../components/template/Main'

export const FinanceiroIndex = props => {
    return <DefaultContainer title={[{ label: "Financeiro" }]}>
        Templete em desenvolvimento, utilize o menu no cabeçalho.
    </DefaultContainer >
}